import TTrialApplicationInviteUserForm from './index.vue';

TTrialApplicationInviteUserForm.install = app => {
  app.component(TTrialApplicationInviteUserForm.name, TTrialApplicationInviteUserForm);
};

export default TTrialApplicationInviteUserForm;
